import * as actionTypes from '../../actions';

const initialState = {
    forms: {},
    signing_templates: {},
    divisions: {},
    email_templates: {},
    text_templates: {},
    email_senders: {},
    event_templates: {},
    locations: {},
    matter_documents: {},
    matter_templates: {},
    tags: {},
    users: {},
    workflows: {},
    automations: {},
    contacts: {},
    matters: {},
    company_documents: {},
    workflow_roles: {},
    workflow_contacts: {},
    event_outcomes: {},
    workflow_steps: {},
    tasks: {},
    workflow_step_categories: {},
    workflow_dispositions: {},
    division_departments: {},
    call_queues: {},
    call_flows: {},
    custom_fields: {},
    lead_sources: {},
}

const reducer = (state = initialState, action) => {

    switch (action.type) {

        case actionTypes.SET_OBJECTS:
            const {obj, collection} = action.payload

            return {
                ...state,
                [collection]: {
                    ...state[collection],
                    [obj._id]: obj
                }
            }

        /*
        Documentation
        
        push multiple object into state in one batch update
        payload should model this: {
            contacts: [
                {_id: ...}
            ],
            divisions: [
                {_id: ...}
            ],
        }
        
        */

        case actionTypes.SET_MULTIPLE_OBJECTS:
            const objects = action.payload
            const _state = JSON.parse(JSON.stringify(state))
            const collections = Object.keys(objects);

            collections.forEach(collection => {
                const objs = objects[collection];
                for (let i = 0; i < objs.length; i++) {
                    const o = objs[i];
                    _state[collection][o._id] = o
                }
               
            })

            return _state

        default: return state;

    }

}

export default reducer;
